import React from 'react';

import Textile from '../common/textile';

export default function QuestionnaireTextBlock(props){
  const { tkey } = props;

  return <div style={{paddingLeft: 40, paddingRight: 40}}><Textile text={I18n.t(tkey)}/></div>
}